// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.box {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
}

.box::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
  z-index: 1;
}

.box-wrap {
  position: relative;
  z-index: 2;
  padding: 20px;
  color: white;
  max-height: 90vh;
  overflow-y: auto;
}

.close-ico {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  z-index: 3;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.close-ico:hover {
  background: rgba(0, 0, 0, 0.7);
}

.close-icon {
  color: white;
  font-size: 24px;
}

.title-box {
  margin-bottom: 20px;
  text-align: center;
}

.title-box h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
}

.title-box ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.title-box li {
  font-size: 14px;
  opacity: 0.9;
}

.analytics-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px; /* compact header */
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.analytics-title h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  color: #ffd700;
}

.des-box {
  background: rgba(255, 255, 255, 0.95);
  position: relative;
  width: 100%;
  border-radius: 8px;
  padding: 20px;
  color: #333;
}

.flow-info {
  background: rgba(248, 249, 250, 0.9);
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 25px;
  border-left: 4px solid #5ea1d8;
}

.flow-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.flow-owner {
  font-size: 14px;
  color: #666;
}

.login-prompt {
  text-align: center;
  padding: 40px 20px;
}

.login-icon {
  font-size: 64px;
  color: #5ea1d8;
  margin-bottom: 20px;
}

.login-prompt h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 20px;
}

.login-prompt p {
  margin: 0 0 25px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.login-btn {
  background: #5ea1d8 !important;
  color: white !important;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
}

.login-btn:hover {
  background: #4a8bc2 !important;
}

.request-form .form-group {
  margin-bottom: 20px;
}
.request-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}
.request-form .form-input,
.request-form .form-textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e1e5e9;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}
.request-form .form-input:focus,
.request-form .form-textarea:focus {
  outline: none;
  border-color: #5ea1d8;
}
.request-form .form-input:disabled,
.request-form .form-textarea:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
}
.request-form .form-textarea {
  resize: vertical;
  min-height: 100px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e1e5e9;
}

.cancel-btn {
  color: #666 !important;
  background: none !important;
  border: 1px solid #e1e5e9 !important;
  padding: 10px 20px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
}

.submit-btn {
  background: #5ea1d8 !important;
  color: white !important;
  border: none !important;
  padding: 10px 24px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  min-width: 140px !important;
  justify-content: center !important;
}

.submit-btn:hover:not(:disabled) {
  background: #4a8bc2 !important;
}

.submit-btn:disabled {
  background: #ccc !important;
  cursor: not-allowed !important;
}

@media (max-width: 768px) {
  .box {
    width: 95%;
    margin: 20px;
  }
  .box-wrap {
    padding: 15px;
  }
  .form-actions {
    flex-direction: column;
    gap: 10px;
  }
  .cancel-btn,
  .submit-btn {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/flow-access-request/flow-access-request.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mFAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA,EAAA,mBAAA;EACA,iDAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AACF;;AAGA;EACE,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAIE;EACE,mBAAA;AADJ;AAIE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAFJ;AAKE;;EAEE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,sBAAA;AAHJ;AAME;;EAEE,aAAA;EACA,qBAAA;AAJJ;AAOE;;EAEE,yBAAA;EACA,mBAAA;AALJ;AAQE;EACE,gBAAA;EACA,iBAAA;AANJ;;AAUA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAPF;;AAUA;EACE,sBAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;AAPF;;AAUA;EACE,8BAAA;AAPF;;AAUA;EACE,8BAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kCAAA;AAPF;;AAUA;EACE,8BAAA;AAPF;;AAUA;EACE,2BAAA;EACA,8BAAA;AAPF;;AAWA;EACE;IACE,UAAA;IACA,YAAA;EARF;EAWA;IACE,aAAA;EATF;EAYA;IACE,sBAAA;IACA,SAAA;EAVF;EAaA;;IAEE,sBAAA;EAXF;AACF","sourcesContent":[".container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.box {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.box::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);\n  z-index: 1;\n}\n\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  padding: 20px;\n  color: white;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.close-ico {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  cursor: pointer;\n  z-index: 3;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s ease;\n}\n\n.close-ico:hover {\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.close-icon {\n  color: white;\n  font-size: 24px;\n}\n\n.title-box {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.title-box h2 {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);\n}\n\n.title-box ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n}\n\n.title-box li {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.analytics-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px; /* compact header */\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.analytics-title h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.header-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  border: none;\n  color: #ffd700;\n}\n\n.des-box {\n  background: rgba(255, 255, 255, 0.95);\n  position: relative;\n  width: 100%;\n  border-radius: 8px;\n  padding: 20px;\n  color: #333;\n}\n\n// Flow Access Request specific styles\n.flow-info {\n  background: rgba(248, 249, 250, 0.9);\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 25px;\n  border-left: 4px solid #5ea1d8;\n}\n\n.flow-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.flow-owner {\n  font-size: 14px;\n  color: #666;\n}\n\n.login-prompt {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.login-icon {\n  font-size: 64px;\n  color: #5ea1d8;\n  margin-bottom: 20px;\n}\n\n.login-prompt h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.login-prompt p {\n  margin: 0 0 25px 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.login-btn {\n  background: #5ea1d8 !important;\n  color: white !important;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 auto;\n}\n\n.login-btn:hover {\n  background: #4a8bc2 !important;\n}\n\n.request-form {\n  .form-group {\n    margin-bottom: 20px;\n  }\n\n  label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n    color: #333;\n    font-size: 14px;\n  }\n\n  .form-input,\n  .form-textarea {\n    width: 100%;\n    padding: 12px;\n    border: 2px solid #e1e5e9;\n    border-radius: 6px;\n    font-size: 14px;\n    transition: border-color 0.3s ease;\n    box-sizing: border-box;\n  }\n\n  .form-input:focus,\n  .form-textarea:focus {\n    outline: none;\n    border-color: #5ea1d8;\n  }\n\n  .form-input:disabled,\n  .form-textarea:disabled {\n    background-color: #f8f9fa;\n    cursor: not-allowed;\n  }\n\n  .form-textarea {\n    resize: vertical;\n    min-height: 100px;\n  }\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #e1e5e9;\n}\n\n.cancel-btn {\n  color: #666 !important;\n  background: none !important;\n  border: 1px solid #e1e5e9 !important;\n  padding: 10px 20px !important;\n  border-radius: 6px !important;\n  font-weight: 500 !important;\n}\n\n.cancel-btn:hover {\n  background: #f8f9fa !important;\n}\n\n.submit-btn {\n  background: #5ea1d8 !important;\n  color: white !important;\n  border: none !important;\n  padding: 10px 24px !important;\n  border-radius: 6px !important;\n  font-weight: 500 !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  min-width: 140px !important;\n  justify-content: center !important;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: #4a8bc2 !important;\n}\n\n.submit-btn:disabled {\n  background: #ccc !important;\n  cursor: not-allowed !important;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .box {\n    width: 95%;\n    margin: 20px;\n  }\n\n  .box-wrap {\n    padding: 15px;\n  }\n\n  .form-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .cancel-btn,\n  .submit-btn {\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
